import { Input, InputOnChangeData, Text, tokens } from "@fluentui/react-components";
import { memo } from "react";
import { useSuggestionFilterFormStyles } from "../styles/SuggestionFilterForm.styles";

type FilterTextFieldsProps = {
  title: string;

  value: string;
  onChange: (_ev: any, data: InputOnChangeData) => void;
  placeholder: string;
};

export const FilterTextFields = memo(({ title, value, onChange, placeholder }: FilterTextFieldsProps) => {
  const styles = useSuggestionFilterFormStyles();
  return (
    <div key={"title"} className={styles.fullWidth}>
      <Text weight="semibold">{title}</Text>
      <Input
        style={{ borderColor: tokens.colorNeutralStroke1 }}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
      />
    </div>
  );
});
